import { render, staticRenderFns } from "./nbn-realized-resource.vue?vue&type=template&id=7d40628d&scoped=true"
import script from "./nbn-realized-resource.vue?vue&type=script&lang=js"
export * from "./nbn-realized-resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d40628d",
  null
  
)

export default component.exports